module.exports = __webpack_public_path__ + "media/mediaProfessionals/block-image-4-273372c7.png";